import React, { useState } from 'react';
import {
  PdfViewerComponent,
  Toolbar,
  Magnification,
  Navigation,
  LinkAnnotation,
  BookmarkView,
  ThumbnailView,
  Print,
  TextSelection,
  Annotation,
  TextSearch,
  FormFields,
  FormDesigner,
  Inject
} from '@syncfusion/ej2-react-pdfviewer';
import axios from 'axios';

const Pdfviewer = () => {
  const [pdfBase64, setPdfBase64] = useState(null);

  const loadPdf = async () => {
    const response = await axios.get(
      'http://127.0.0.1:8004/reports/pdf-report/',
      { withCredentials: true }
    );

    const data = response.data;

    setPdfBase64(`data:application/pdf;base64,${data.pdf}`);
  };

  return (
    <div style={{ padding: "20px" }} onContextMenu={(e) => e.preventDefault()}>
      <button onClick={loadPdf} style={{ marginBottom: "20px" }}>
        Load PDF
      </button>

      {pdfBase64 && (
        <PdfViewerComponent
          id="container"
          documentPath={pdfBase64}
          resourceUrl="https://cdn.syncfusion.com/ej2/31.2.2/dist/ej2-pdfviewer-lib"
          style={{ height: "80vh" }}
          enableDownload={false}
          enablePrint={false}
        >
          <Inject services={[
            Toolbar,
            Magnification,
            Navigation,
            Annotation,
            LinkAnnotation,
            BookmarkView,
            ThumbnailView,
            Print,
            TextSelection,
            TextSearch,
            FormFields,
            FormDesigner
          ]}/>
        </PdfViewerComponent>
      )}
    </div>
  );
};

export default Pdfviewer;
